export default function CTASection() {
  return null;
}
